import React, { useState } from 'react';

import { Link } from '../Link';
import iconMoney from '../../images/Header/icon-money.svg';
import iconCog from '../../images/Header/icon-cog.svg';
import iconDev from '../../images/Header/icon-dev.svg';
import iconDocs from '../../images/Header/icon-docs.svg';
import iconIntegration from '../../images/Header/icon-integration.svg';
import iconPagarme from '../../images/Header/icon-pagarme.svg';
import iconSupport from '../../images/Header/icon-support.svg';
import iconBillet from '../../images/Header/icon-billet.svg';
import iconDoubt from '../../images/Header/icon-doubt.svg';
import iconBusiness from '../../images/Header/icon-business.svg';
import Tab from './Tab';

import * as S from './styles';
import { useAnalyticsEvents } from '../../hooks/useAnalyticsEvent';

const tabOne = [
  {
    name: 'Guia de integração',
    path:
      'https://docs.pagar.me/page/guias-pagarme?_gl=1*r3p3fd*_gcl_aw*R0NMLjE3MzMxNTkwMzEuQ2p3S0NBaUEwclc2QmhBY0Vpd0FRSDI4SXZ2M1ZsVF96aUQxTTNsd3ZiNVRDclZicGpZV1l2UnBSMkNJMnBHOG5Bc2hXRk1UX0l6S1VCb0NQZmdRQXZEX0J3RQ..*_gcl_au*ODY1NDQ2OTQ3LjE3MzcxMjMwOTkuMjE0NTg0NTg4OC4xNzM3NDA5NjM5LjE3Mzc0MDk2Mzg.*_ga*MTg0MjMyMzAzMS4xNzM3MTIzMDk4*_ga_D3WKQ4C3N8*MTczNzQ3ODQwMS45LjEuMTczNzQ4MjI5OS4zNi4wLjA.',
    image: iconIntegration,
    subtitle: 'Saiba como começar a usar o Pagar.me',
    asLinkFromGatsby: true,
  },
  {
    name: 'Documentação',
    path:
      'https://docs.pagar.me/?_gl=1*1f5bvy4*_gcl_aw*R0NMLjE3MzMxNTkwMzEuQ2p3S0NBaUEwclc2QmhBY0Vpd0FRSDI4SXZ2M1ZsVF96aUQxTTNsd3ZiNVRDclZicGpZV1l2UnBSMkNJMnBHOG5Bc2hXRk1UX0l6S1VCb0NQZmdRQXZEX0J3RQ..*_gcl_au*ODY1NDQ2OTQ3LjE3MzcxMjMwOTkuMjE0NTg0NTg4OC4xNzM3NDA5NjM5LjE3Mzc0MDk2Mzg.*_ga*MTg0MjMyMzAzMS4xNzM3MTIzMDk4*_ga_D3WKQ4C3N8*MTczNzQ3ODQwMS45LjEuMTczNzQ4MjI5OS4zNi4wLjA.',
    image: iconDocs,
    subtitle: 'Referências e bibliotecas da nossa API',
    asLinkFromGatsby: true,
  },
];

const tabTwo = [
  {
    name: 'Dúvidas',
    image: iconDoubt,
    subtitle: 'Confira nossa Central de Ajuda',
    path: 'https://pagarme.helpjuice.com/',
  },
  {
    name: 'Boleto DDA',
    image: iconBillet,
    subtitle: 'Consulte seu boleto',
    path: '/boletos',
    asLinkFromGatsby: true,
  },
];

const BurguerMenu = ({ blog }) => {
  const [isOpenSideMenu, setIsOpenSideMenu] = useState(false);

  const { sendEvent } = useAnalyticsEvents();

  const sendMenuEvent = (ctaReference, description, sectionReference = 'Header') => {
    sendEvent({
      label: '',
      entity: 'page',
      name: 'cta pagarme',
      description: description,
      deduplicate: false,
      section_reference: sectionReference,
      cta_reference: ctaReference,
    });
  };

  const sendSubmenuEvent = ({ cta, subMenu }) => {
    sendEvent({
      label: '',
      entity: 'page',
      name: 'cta pagarme',
      description: `Evento disparado no menu de ${cta} no cabeçalho da home`,
      deduplicate: false,
      section_reference: 'Menu',
      cta_reference: cta,
      section_submenu: subMenu,
    });
  };

  const sideBurgerMenu = () => {
    setIsOpenSideMenu((oldIsOpenSideMenu) => !oldIsOpenSideMenu);
  };

  const handleHeaderEvent = (label) => {
    sendMenuEvent(label, `Evento disparado quando o usuário clicar no link "${label}" no cabeçalho da home`);
  };

  return (
    <S.MobileView>
      <S.InputOpenSideMenu type="checkbox" checked={isOpenSideMenu} onChange={sideBurgerMenu} />

      <S.BurguerIcon onClick={sideBurgerMenu} aria-label="burguer-button">
        <span />
      </S.BurguerIcon>

      <S.SideMenu>
        <S.SideMenuInner>
          {blog ? (
            <>
              <li>
                <Link to="/blog">Início</Link>
              </li>
              <Tab tabItems={tabOne} tabTitle="Categorias" />
              <li>
                <Link to="/">Ir para o site</Link>
              </li>
            </>
          ) : (
            <>
              <li>
                <Link onClick={() => handleHeaderEvent('Produtos')} to="/produtos" absolute>
                  <img src={iconCog} alt="produtos" />
                  {''}
                  Produtos
                </Link>
              </li>
              <li>
                <Link onClick={() => handleHeaderEvent('Ofertas')} to="/ofertas" absolute>
                  <img src={iconMoney} alt="ofertas" />
                  {''}
                  Ofertas
                </Link>
              </li>

              <li>
                <Link onClick={() => handleHeaderEvent('Negócios que atendemos')} to="/negocios-que-atendemos" absolute>
                  <img src={iconBusiness} alt="Negócios que atendemos" />
                  {''}
                  Negócios que atendemos
                </Link>
              </li>

              <li>
                <Link onClick={() => handleHeaderEvent('O Pagar.me')} to="/sobre">
                  <img src={iconPagarme} alt="ofertas" />O Pagar.me
                </Link>
              </li>

              <li>
                <Tab
                  tabItems={tabOne.map((item) => ({ ...item, sendEvent: sendSubmenuEvent }))}
                  tabTitle="Desenvolvedores"
                  image={iconDev}
                />
              </li>
              <li>
                <Tab
                  image={iconSupport}
                  tabItems={tabTwo.map((item) => ({ ...item, sendEvent: sendSubmenuEvent }))}
                  tabTitle="Suporte"
                />
              </li>
            </>
          )}
        </S.SideMenuInner>
        <S.ClientArea>
          <S.RegisterButton to="/ofertas" absolute onClick={() => handleHeaderEvent('Cadastrar agora')}>
            Cadastrar agora
          </S.RegisterButton>
        </S.ClientArea>
      </S.SideMenu>
      <S.Overflow onClick={sideBurgerMenu} />
    </S.MobileView>
  );
};

export default BurguerMenu;
